<template>
  <div class="stps">
    <div class="stps-item" v-for="(item, index) in list" :key="index">
      <div class="outer-circle" v-if="index == 0">
        <div class="inner-circle"></div>
        <div class="line" v-if="list.length !== index + 1"></div>
      </div>
      <div class="noactive-outer-circle" v-else>
        <div class="outer-circle">
          <div class="inner-circle"></div>
          <div class="line" v-if="list.length !== index + 1"></div>
        </div>        
      </div>

      <div class="step-text">
        <span class="time" :style="{ color: index == 0 ? '#236dff' : '' }">{{ item.createTime }}</span>
        <span class="state" :style="{ color: index == 0 ? '#236dff' : '' }">{{ item.agentName }}</span>
        <span class="desc">{{ item.reason }}</span>
        <span class="action">操作人：{{ item.createName }}</span>
      </div>
    </div>
    <no-data v-if="!list.length"></no-data>
  </div>
</template>
<script>
export default {
  name:'detailAttributionRecord',
  props:['id'],
  data() {
    return{
      list:[]
    }
  },

  created(){
    this.getInsureList();
  },

  methods:{
    getInsureList() {
      this.$http({
        url: `/buz/customerBase/read/belong/list/${this.id}`,
        type: "POST"
      }).then((res) => {
        this.list = res.data;
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .stps {
  .stps-item {
    margin-bottom: 19px;
    display: flex;
    align-items: center;
    .outer-circle {
      width: 11px;
      height: 11px;
      border: 1px solid #236dff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      flex-shrink: 0;
    }
    .inner-circle {
      background-color: #236dff;
      width: 7px;
      height: 7px;
      border-radius: 50%;
    }
    .line {
      position: absolute;
      left: 50%;
      top: 50%;
      margin-top: 8px;
      margin-left: -1px;
      height: 25px;
      border-left: 1px dashed #d0d2d5;
    }

    .noactive-outer-circle {
      width: 11px;
      height: 11px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      flex-shrink: 0;
      .outer-circle {
        width: 11px;
        height: 11px;
        background: #F7F7F7;
        border: 1px solid #F7F7F7;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        flex-shrink: 0;
      }
      .inner-circle {
        background-color: #d0d2d5;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        margin-left: -1px;
      }
      .line {
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: 7px;
        margin-left: -1px;
        height: 25px;
        border-left: 1px dashed #d0d2d5;
      }
    }

    .step-text {
      margin-left: 10px;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #666e7b;
      font-size: 12px;
      .time {
        width: 150px;
      }
      .state {
        width: 90px;
        color: #000;
      }
      .desc {
        margin-left: 50px;
        width: 800px;
      }
      .action {
        width: 140px;
        margin-left: 60px;
        color: #727C8E;
      }
      & .active {
        color: #236dff;
        font-weight: bold;
      }
      & .active2 {
        color: #272933;
      }
    }
  }
}
</style>